import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import InputUserDataPanel from './InputUserDataPanel';
import LoadingSpinner from '../../Components/LoadingSpinner';
import { validateEmail } from '../../../Helpers/ValidatorHelper';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../Providers/AuthProvider';
import { useUser } from '../../../Providers/UserProvider';
import { capitalizeFirstLetter } from '../../../Helpers/CustomConverter';
import InformationErrorModal from '../../Components/Modals/InformationErrorModal';


const AddEditUser = ({ isAddUserPanelVisible, setIsAddUserPanelVisible, handlingUser, setHandlingUser, baseUser, setBaseUser, isEdit, selectedRoles, setSelectedRoles, baseRoles }) => {
    const { t } = useTranslation();
    const [error, setError] = useState('')
    const { authState } = useAuth()
    const { addCustomerUser, updateCustomerUser, isAddingEditingCustomerUser } = useUser()
    const [showAddUserConfirmationMessage, setShowAddUserConfirmationMessage] = useState(false)


    const handleCancelButtonClick = () => {
        setHandlingUser({ userId: '', userLogin: '', firstName: '', lastName: '', custId: '', phoneNumber: '' })
        setBaseUser({ userId: '', userLogin: '', firstName: '', lastName: '', custId: '', phoneNumber: '' })
        setSelectedRoles([])
        setError('')
        setIsAddUserPanelVisible(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name == 'firstName' || name == 'lastName') {
            const capitalizeValue = capitalizeFirstLetter(value)
            setHandlingUser({
                ...handlingUser,
                [name]: capitalizeValue
            });
        } else {
            setHandlingUser({
                ...handlingUser,
                [name]: value
            });
        }
        setError('')
    }

    const handleSaveUserButtonClick = async () => {
        if (validateEmail(handlingUser.userLogin)) {
            if (isEdit) {
                if (baseUser != handlingUser || baseRoles != selectedRoles) {
                    if (handlingUser.firstName === '' || handlingUser.lastName === '' || handlingUser.userLogin === '') {
                        setError('Wszystkie pola muszą być wypełnione')
                    } else {
                        var result = await updateCustomerUser({ userId: handlingUser.userId, firstName: handlingUser.firstName, lastName: handlingUser.lastName, userLogin: handlingUser.userLogin, custId: handlingUser.custId, roles: selectedRoles, phoneNumber: handlingUser.phoneNumber })
                        if (result === 204) {
                            setHandlingUser({ userId: '', userLogin: '', firstName: '', lastName: '', custId: '', phoneNumber: '' })
                            setBaseUser({ userId: '', userLogin: '', firstName: '', lastName: '', custId: '', phoneNumber: '' })
                            setSelectedRoles([])
                            setIsAddUserPanelVisible(false);
                        } else {
                            if (result) {
                                setError(result)
                            } else {
                                setError("Błąd podczas zapisu użytkownika!")
                            }
                        }
                    }
                } else {
                    setError('Nie wprowadzono żadnych zmian!');
                }
            } else {
                if (handlingUser.firstName === '' || handlingUser.lastName === '' || handlingUser.userLogin === '') {
                    setError('Wszystkie pola muszą być wypełnione')
                } else {
                    var result = await addCustomerUser({ userId: '', firstName: handlingUser.firstName, lastName: handlingUser.lastName, userLogin: handlingUser.userLogin, custId: authState.custId, roles: selectedRoles, phoneNumber: handlingUser.phoneNumber })
                    if (result === 204) {
                        setShowAddUserConfirmationMessage(true)
                        setHandlingUser({ userId: '', userLogin: '', firstName: '', lastName: '', custId: '', phoneNumber: '' })
                        setBaseUser({ userId: '', userLogin: '', firstName: '', lastName: '', custId: '', phoneNumber: '' })
                        setSelectedRoles([])
                        setIsAddUserPanelVisible(false);
                    } else {
                        if (result) {
                            setError(result)
                        } else {
                            setError("Błąd podczas dodawania użytkownika!")
                        }
                    }
                }
            }
        } else {
            setError('Podaj poprawny adres e-mail.')
        }
    }

    return <>
        <InformationErrorModal
            show={showAddUserConfirmationMessage}
            setShow={() => { setShowAddUserConfirmationMessage(false) }}
            title="Informacja"
            message={'Użytkownik został dodany pomyślnie, została wysłana wiadomośc e-mail z instrukcją do nadania hasła.'}
            isError={false}
            isVersionControlInfo={false}
            showCloseButton={false}
        />
        <Modal size='lg' show={isAddUserPanelVisible} onHide={handleCancelButtonClick} centered>
            <Modal.Header closeButton>
                <Modal.Title>{isEdit ? "Edycja użytkownika" : t("new_user")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isAddingEditingCustomerUser ? <LoadingSpinner /> : <InputUserDataPanel
                    handleSaveUserButtonClick={handleSaveUserButtonClick}
                    user={handlingUser}
                    handleChange={handleChange}
                    isEdit={isEdit}
                    selectedRoles={selectedRoles}
                    setSelectedRoles={setSelectedRoles}
                    error={error}
                />}
            </Modal.Body>
        </Modal>
    </>
}
export default AddEditUser;